import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { format } from "date-fns";
import { hi } from "date-fns/locale";
import { Link, useNavigate } from "react-router-dom";
import { Circles } from 'react-loader-spinner';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import DOMPurify from 'dompurify';

const baseUrl = "https://api.shabdtoday.com/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
    //return text.substring(0, maxLength) + '...';
  }
  return text;
};
const local = "https://localhost:44351/api/home/bussiness"
const online = "https://api.shabdtoday.com/api/home/bussiness"
const clicklocal = "https://localhost:44351/api/home/update-viewcount"
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount"

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};

const renderHtmlContent = (html) => {
  const sanitizedHtml = DOMPurify.sanitize(html);
  return { __html: sanitizedHtml };
};


function Buisness() {
  const [posts, setPosts] = useState([]);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const observer = useRef();

  const fetchNews = async () => {
    if (!hasMore || fetching) return;

    setFetching(true);
    try {
      const response = await axios.get(`${online}?page=${page}&limit=5`);

      if (response.data && response.data.bussiness.length > 0) {
        setNews((prevNews) => {
          const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
          const newNews = response.data.bussiness.filter((item) => !existingIds.has(item.mainKhabarId));
          return [...prevNews, ...newNews];
        });
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching news:", error.message);
    }
    setFetching(false);
    setLoading(false);
  };

  useEffect(() => {
    fetchNews();
  }, []);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        fetchNews();
      }
    });
    const target = document.getElementById("load-more");
    if (target) observer.current.observe(target);

    return () => observer.current && observer.current.disconnect();
  }, [news]);

  const handleNewsClick2 = async (slug, mainKhabarId) => {
    try {
      const response = await axios.post(`${clickonline}`, {
        mainKhabarId: mainKhabarId
      });

      if (response.status === 200) {
        // console.log("View count updated successfully", response.data);
        window.location.href = `/News-Details/${slug}`;
      } else {
        console.error("Failed to update view count", response.data);
      }
    } catch (error) {
      console.error("Error updating view count:", error.response ? error.response.data : error.message);
    }
  };

  const handleNewsClick = (trendingTagId) => {
    navigate(`/NewsDetails/${trendingTagId}`);
  };

  const getTimeAgoInHindi = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} सेकंड पहले`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} मिनट पहले`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} घंटे पहले`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
      return `${diffInDays} दिन पहले`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths} महीने पहले`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} साल पहले`;
  };
  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी",
      "फरवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्टूबर",
      "नवंबर",
      "दिसंबर",
    ];
    const seconds = date.getSeconds();
    const minute = date.getMinutes();
    var hour = date.getHours();
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
  };
  const generateShareLinks = (mainKhabarId, newsHeading) => {
    const encodedNewsHeading = encodeURIComponent(newsHeading);
    const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodedNewsHeading}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encodedNewsHeading} ${url}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodedNewsHeading}&url=${url}`,
      instagram: `https://www.instagram.com/`
    };
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        {/* <Circles height="30" width="30" color="#f7265c" ariaLabel="loading" visible={true} /> */}
      </div>
    );
  }


  if (error) {
    return <div>Error: {error}</div>;
  }


  return (
    <div>

      <div
        className="ak-block ak-block-3  ak-block-column ak-block-module-thumb-round ak-block-inner-boxed ak-block-width-1 clearfix"
        id="block_65f7f61f36732_9"
      >
        <div className="ak-block-header ak-block-header-style-5 no-tabs">
          <div
            className="main-wdgt container"
            id="widget-rs-4937"
            data-vars-widget-type="home"
            data-vars-widget-name="astrology"
            data-vars-orderid={10}
          > <div>
              <h1 className="head">
                <Link to="/Business-News" title="धर्म" >
                  <span style={{ color: "crimson" }}>
                    बिज़नेस </span>
                </Link>
              </h1>
            </div>

          </div>
        </div>
        <div className="ak-block-inner clearfix">
          <div className="ak-block-posts clearfix">
            {news.map((post) => {
              const shareLinks = generateShareLinks(post.mainKhabarId, post.newsHeading);
              return (
                <article key={post.mainKhabarId} className="bordergap ak-module ak-module-1-small ak-column-module ak-module-meta-hide clearfix post-225 post type-post status-publish format-standard has-post-thumbnail  category-business category-entertainment category-tech-science category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news">
                  <div className="ak-module-inner clearfix">
                    <div className="ak-module-featured">
                      <div className="ak-featured-cover">
                        <Link
                          to={`/News-Details/${post.slug}`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNewsClick2(post.slug, post.mainKhabarId);
                          }}
                          className="ak-featured-link"
                          rel="bookmark"
                          title={stripHtmlTags(post.newsTag, 210)}
                        >
                          <div className="ak-featured-thumb  size-715">
                            <img
                              loading="lazy"
                              decoding="async"
                              width={120}
                              height={86}
                              src={baseUrl + post.newsImage}
                              className="attachment-newsy_120x86 size-newsy_120x86 lazyload wp-post-image"
                              alt=""
                              data-src={`${image_resize}?url=${baseUrl}${post.newsImage}&w=120&h=86&outtype=webp`}
                              data-sizes="auto"
                              data-srcset={`${image_resize}?url=${baseUrl}${post.newsImage}&w=120&h=86&outtype=webp`}
                              data-expand={700}
                            />
                          </div>
                          {/* <FontAwesomeIcon icon={faClock} style={{ color: "grey", fontSize: "12px" }} /> */}
                          &nbsp;
                          <span style={{ color: "grey", fontSize: "12px" }}>
                            {getTimeAgoInHindi(post.date)}
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="ak-module-details">
                      <h1 className="ak-module-title" style={{ textAlign: "justify", lineHeight: "30px" }}>
                        <Link
                          to={`/News-Details/${post.slug}`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNewsClick2(post.slug, post.mainKhabarId);
                          }}
                          rel="bookmark"
                          title={stripHtmlTags(post.newsTag)}
                        >
                          <span style={{ fontSize: "15px", lineHeight: "20px", fontWeight: "600", textAlign: "justify" }} dangerouslySetInnerHTML={renderHtmlContent(post.newsTag)} />
                        </Link>
                      </h1>
                      <div className="ak-module-meta">
                        <div className="ak-module-time">
                          <Link
                            to={`/News-Details/${post.slug}`}
                            onClick={(e) => {
                              e.preventDefault();
                              handleNewsClick2(post.slug, post.mainKhabarId);
                            }}
                            className="ak-module-meta-published"
                          >
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>

    </div>
  );

}

export default Buisness
